import { jwtDecode, type JwtPayload } from 'jwt-decode';

export const JWT_TOKEN_KEY = 'JWT_TOKEN';
const BEARER_PREFIX = 'Bearer ';

function stripBearerPrefix(token: string): string {
  return token.startsWith(BEARER_PREFIX) ? token.slice(BEARER_PREFIX.length) : token;
}

export function getJwt(): string | null {
  try {
    return window.localStorage.getItem(JWT_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function keepJwt(token: string): void {
  window.localStorage.setItem(JWT_TOKEN_KEY, token);
}

export function forgetJwt(): void {
  window.localStorage.removeItem(JWT_TOKEN_KEY);
}

export function validateJwt(token: string | null | undefined): boolean {
  if (!token) return false;

  try {
    const claim = jwtDecode<JwtPayload>(stripBearerPrefix(token));
    const now = Date.now() / 1000;
    return Boolean(claim && (!claim.exp || claim.exp > now) && (!claim.nbf || claim.nbf < now));
  } catch {
    return false;
  }
}
